module.exports = __webpack_public_path__ + "static/media/MaterialCommunityIcons.d15c1216.ttf";